<template>
  <toolbar-button
    id="pw-cart-toolbar-button"
    :[linkAttribute]="link"
    :aria-label="$t('openCart')"
    @click="track"
  >
    <toolbar-badge
      id="pw-cart-toolbar-count"
      :loading="loading"
      :content="cartCount"
      :icon="mdiCart"
    />
  </toolbar-button>
</template>

<script setup lang="ts">
import ToolbarBadge from '@/components/toolbar/ToolbarBadge.vue'
import ToolbarButton from '@/components/toolbar/ToolbarButton.vue'
import useCartCount from '@/modules/cart/useCartCount'
import usePortalSettings from '@/modules/portalSettings/usePortalSettings'
import ApplicationHeaderEvent from '@/modules/tracking/events/applicationHeader'
import { trackEvent } from '@/modules/tracking/useTracking'
import { mdiCart } from '@mdi/js'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

useCartCount().loadCartCount()

const { cartCount, loading } = storeToRefs(useCartCount())
const { portalSettings } = storeToRefs(usePortalSettings())

const linkAttribute = computed(() => (portalSettings.value.platformCartLink ? 'href' : 'to'))
const link = computed(() =>
  portalSettings.value.platformCartLink
    ? portalSettings.value.platformCartLink
    : { name: 'ShoppingCart' }
)

const track = () => {
  trackEvent(ApplicationHeaderEvent.Cart)
}
</script>
